import React, { useState, useEffect, useRef } from "react";
import clubs from "../clubs.json";

function SearchBar({
  setSelectedClub,
  onSubmit,
  setBlur,
  setCriteriaChecked,
  setShouldWatch,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const wrapperRef = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setSuggestions([]);
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setSearchTerm(value);
    if (value === "") {
      setSuggestions([]);
    } else {
      // filter the clubs based on the searchTerm
      const filteredClubs = clubs.filter((club) =>
        club.name.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filteredClubs.slice(0, 3)); // limit to 5 suggestions
    }
  };

  const handleSelect = (club) => {
    setSearchTerm(club.name);
    setSuggestions([]);
    // setSelectedClub(club);
    // setCriteriaChecked(false);
    // setShouldWatch(false);
    // onSubmit(club);
    // setBlur(true); // Set blur to false when a club is selected
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchTerm === "") {
      setSelectedClub(null);
      setBlur(true); // Set blur to true when no club is selected
    } else {
      const selected = clubs.find(
        (club) => club.name.toLowerCase() === searchTerm.toLowerCase()
      );
      setSelectedClub(selected);
      setCriteriaChecked(false);
      setShouldWatch(true);
      onSubmit(selected);
      setBlur(true); // Set blur to false when a club is selected
    }
  };

  return (
    <div className="search-container" ref={wrapperRef}>
      <form className="flex-row search-wrapper" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Barcelona"
          value={searchTerm}
          onChange={handleChange}
        />
        <button type="submit">
          <img className="icon" src="/images/search.png" alt="Search icon" />
        </button>
      </form>
      {suggestions.length > 0 && (
        <div className="flex-column suggestions-wrapper">
          {suggestions.map((club) => (
            <div
              key={club.id}
              onClick={() => handleSelect(club)}
              className="flex-row suggestion-item"
            >
              <img
                className="badge small"
                src={`https://media.api-sports.io/football/teams/${club.id}.png`}
              />
              {club.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SearchBar;
